import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useAdminQueues(service) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  async function fetchAdminQueues() {
    setLoading(true);
    const { response, data } = await API.admin.fetchQueues(token, service);

    if (response.ok) {
      setResult(data);
      setError(null);
    } else {
      setResult(null);
      setError(data.message);
    }

    setLoading(false);
  }

  useEffect(() => {
    fetchAdminQueues();
  }, [token, service]);

  return {
    loading,
    error,
    queues: result,
    refresh: fetchAdminQueues,
  }
}
